import React from 'react';

export default function Image(props) {
  return (
    <>
      <picture>
        {/* <!-- Mobile & Small Devices (up to 991px) --> */}
        <source media="(max-width: 991px)" srcset={props.mobileImageSrc} type="image/webp"/>
        {/* <!-- Desktop / Default --> */}
        <img src={props.imageSrc} alt={props.imageAltText} className={props.imageClass}></img>
      </picture>
    </>
  )
}
